<template>
  <Dialog
    :header="`Playback (${temp?.Name || 'Unknown'})`"
    modal
    class="playback-run-modal"
    v-model:visible="isOpened"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '25vw' }"
  >
    <form @submit.prevent="onSubmit(!v$.$invalid)">
      <!-- :class="{'display-none': isLoadingGetData}" -->

      <!-- <div class="p-input-group">
            <span class="p-float-label p-mt-5">
              <Calendar id="startDateTime" v-model="startDateTime" showTime hourFormat="24" />
              <label
                for="startDateTime"
                :class="{ 'p-error': v$.startDateTime.$invalid && isSubmitted }"
                >{{ $t("Start Date and Time") }}</label
              >
            </span>
            <small
              v-if="
                (v$.startDateTime.$invalid && isSubmitted) ||
                v$.startDateTime.$pending.$response
              "
              class="p-error"
              >{{
                v$.startDateTime.required.$message.replace(
                  "Value",
                  $t("Current password")
                )
              }}</small
            >
          </div> -->

      <InputGroup class="p-mt-2">
        <InputGroupAddon>
          <i class="pi f7-icons icon-date size-18"></i>
        </InputGroupAddon>
        <FloatLabel>
          <Calendar
            id="startDateTime"
            v-model="v$.startDateTime.$model"
            iconDisplay="input"
            showTime
            hourFormat="24"
            inputId="startDateTime"
            class="w-full small-calendar"
            @date-select="onDateSelect"
          >
          </Calendar>
          <label for="startDateTime">Start Date and Time</label>
        </FloatLabel>
      </InputGroup>
      <InputGroup class="p-mt-6">
        <InputGroupAddon>
          <i class="pi f7-icons icon-date size-18"></i>
        </InputGroupAddon>
        <FloatLabel>
          <Calendar
            id="endDateTime"
            v-model="v$.endDateTime.$model"
            iconDisplay="input"
            showTime
            hourFormat="24"
            inputId="endDateTime"
            class="w-full small-calendar"
            panelClass="small-calendar-panel small-calendar"
            :pt="{
              input: { class: 'text-xs p-2 h-8 w-32' },
            }"
            @date-select="onDateSelect"
          >
          </Calendar>
          <label for="endDateTime">End Date and Time</label>
        </FloatLabel>
      </InputGroup>

      <InputGroup  style="    max-width: 235px;
"
      class="p-mt-6">
        <InputGroupAddon>
          <i class="pi f7-icons icon-home size-18"></i>
        </InputGroupAddon>
        <FloatLabel>
          <Dropdown
            id="timeZone"
            v-model="v$.timeZone.$model"
            :options="timeZones"
            optionLabel="name"
            optionValue="code"
            :filter="true"
            :class="{ 'p-invalid': v$.timeZone.$invalid && isSubmitted }"
          />
          <label for="timeZone">{{ $t("CUSTOMERS_MSG049") }}</label>
        </FloatLabel>
      </InputGroup>
    </form>

    <template #footer>
      <Button
        severity="success"
        :label="$t('PLAYBACK_MSG001')"
        class="w-100 p-ml-0 button-form p-button-sm"
        @click="onSubmit(!v$.$invalid)"
      />

      <div v-if="isLoading" class="overlay">
        <ProgressSpinner />
      </div>
      <Toast />

      <!-- :class="{'disabled': isLoadingGetData || isLoading}" -->
    </template>
  </Dialog>
</template>


<script>
import InputGroup from "primevue/inputgroup";
import InputGroupAddon from "primevue/inputgroupaddon";

import Dialog from "primevue/dialog";
import Button from "primevue/button";
import FloatLabel from "primevue/floatlabel";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import Tooltip from "primevue/tooltip";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import { email, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { useI18n } from "vue-i18n";
import Divider from "primevue/divider";
import CountryService from "../../service/country-service";
import TimeZoneService from "../../service/time-zone-service";
import CustomersService from "../../service/customers-service";
import { f7 } from "framework7-vue";
import { useStore, mapGetters } from "vuex";
import moment from "moment-mini";
import ProgressSpinner from "primevue/progressspinner";
import { useToast } from "primevue/usetoast";

import {
  sortArrayByObjProps,
  getFromStorage,
  setInStorage,
} from "../../js/helper";

import { ref, onMounted, computed, reactive, watch, watchEffect } from "vue";
import _ from "lodash";

export default {
  name: "playback-run-modal",

  components: {
    Dialog,
    Button,
    InputText,
    InputNumber,
    Divider,
    Dropdown,
    Calendar,
    FloatLabel,
    InputGroup,
    InputGroupAddon,
    ProgressSpinner,
  },
  props: {
    temp: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    isOpened: { type: Boolean, default: false },
  },
  emits: ["update:isOpened", "statusChanged"],
  computed: {
    ...mapGetters(["info"]),
  },
  directives: {
    tooltip: Tooltip,
  },

  setup(props, { emit }) {
    const { t } = useI18n();
    const store = useStore();
    const MinorToken = computed(() => store.getters.MinorToken);
    const MajorToken = computed(() => store.getters.MajorToken);
   // const UserInfo = computed(() => store.getters.UserInfo);
    const info = computed(() => store.getters.info);
    const countryService = ref(new CountryService());
    const countries = ref();
    const startDateTime = ref(null);
    const endDateTime = ref(null);
    const isLoading = ref(false);
    const toast = useToast();
    const userInfo = getFromStorage("userInfo");


    onMounted(() => {
      countries.value = countryService.value.getCountries();
      countries.value =
        countries.value && countries.value.length
          ? sortArrayByObjProps(countries.value, [
              { prop: "Country", direction: 1 },
            ])
          : [];
      timeZones.value = timeZoneService.value.getTimeZones();

      let uInfo = userInfo.UserInfo
     // console.log('uInfo', userInfo);
      if (
        uInfo?.TimeZoneID ||
        uInfo?.TimeZone
      ) {
        state.timeZone = !uInfo?.TimeZoneID
          ? timeZones.value.find(
              (itm) =>
                parseFloat(itm.code) ===
                parseFloat(uInfo?.TimeZone)
            )?.code
          : timeZones.value.find(
              (itm) => itm.id === uInfo?.TimeZoneID
            )?.code;
      }

      // getPreEditCustomerInfo();
      state.startDateTime = moment().subtract(1, 'days').toDate();
      state.endDateTime = moment().toDate();
    });

    const isSubmitted = ref(false);

    const timeZoneService = ref(new TimeZoneService());
    const timeZones = ref();
    const customersService = new CustomersService();

    const state = reactive({
      startDateTime: "",
      endDateTime: "",
      country:  "AUS", //uInfo?.CountryCode ||
      timeZone: "",
    });

    const rules = {
      startDateTime: { required },
      endDateTime: { required },
      timeZone: { required },
    };
    const v$ = useVuelidate(rules, state);

    const getPlaybackData = async (data, optimizedState) => {
      const tz = state.timeZone;

      isLoading.value = true;

      try {
        let result = await store.dispatch("GET_PLAYBACK_ARR", data);

        if (result.MajorCode === "000" && result.Data) {
          const hisArray = result.Data.HisArry;

          if (!hisArray.length) {
            isLoading.value = false;
            toast.add({
              severity: "info",
              position: "top-center",
              summary: "Playback",
              detail: "No Data Found",
              life: 3000,
            });
          } else {
            isLoading.value = false;

            setInStorage({
              name: "historyArray",
              data: hisArray,
            });

            setInStorage({
              name: "historyEvents",
              data: result.Data.HisEvents?.length ? result.Data.HisEvents : [],
            });

            emit("update:isOpened", false);
            setTimeout(() => {
              f7.views.main.router.navigate({
                name: "asset-playback",
                params: {
                  imei: props.temp.IMEI,
                  // optimisedState: optimizedState,
                  // isIgnore: data.IsIgnore,
                  from: data.From,
                  to: data.To,
                  timeZone: tz,
                },
              });
            }, 300);

            // router.push({
            //   name: "asset-playback-show",
            //   params: {
            //     imei: data.IMEI,
            //     optimisedState: optimizedState,
            //     isIgnore: data.IsIgnore,
            //     from: data.From,
            //     to: data.To,
            //     timeZone: tz,
            //   },
            // });
          }
        } else if (result.MajorCode === "100" && result.MinorCode === "1002") {
          isLoading.value = false;
          app.dialog.alert(
            LANGUAGE.ASSET_PLAYBACK_MSG04,
            LANGUAGE.ASSET_PLAYBACK_MSG00
          );
        } else {
          isLoading.value = false;
          app.dialog.alert(
            LANGUAGE.ASSET_PLAYBACK_MSG19,
            LANGUAGE.ASSET_PLAYBACK_MSG00
          );
        }
      } catch (error) {
        isLoading.value = false;
        // app.dialog.close();
        // app.dialog.alert("Error occurred while fetching playback data");
      }
    };

    const onSubmit = async (isFormValid) => {
      isSubmitted.value = true;


      // console.log("startDateTime.value", state.startDateTime);

      // console.log("from", from);

      if (!isFormValid) {
        return;
      }

      let from = moment
        .utc(new Date(state.startDateTime))
        .format("YYYY-MM-DDTHH:mm:ss");
      let to = moment
        .utc(new Date(state.endDateTime))
        .format("YYYY-MM-DDTHH:mm:ss");

      // if (from >= to) {
      //     f7.dialog.alert('End date and time must be greater than start date and time');
      //     return;
      // }

      let data = {
        MinorToken: userInfo.MinorToken,
        //MajorToken: userInfo.MajorToken,
        Code: props.temp.Id,
        From: from,
        To: to,
        // IsIgnore: isIgnoreSwitcher.is(':checked')
      };

      console.log("data", data);

      getPlaybackData(data); //, optimizedSwitcher.is(':checked')
    };

    watch(
      () => props.isOpened,
      (newVal, oldVal) => {
        if (oldVal === true) {
          emit("update:isOpened", false);
        }
      },
      () => props.temp,
      (newVal, oldVal) => {
        console.log("temp", newVal);
        console.log("oldVal", oldVal);
      }
    );

    const getPreEditCustomerInfo = async () => {
      let data = {
        MajorToken: MajorToken.value,
        MinorToken: MinorToken.value,
      };
      // if (props.f7route.query.customerCode) {
      //   data.Code = props.f7route.query.customerCode;
      //   state.code = props.f7route.query.customerCode;
      // }
      // isLoadingGetData.value = true;
      // let result = await customersService.getPreEditCustomerInfo(data);
      // isLoadingGetData.value = false;
      if (!result) return;

      // if (state.code && result.CustomerInfo) {
      //   setCustomerInfo(result.CustomerInfo);
      // }
      // if (state.code && result.ContactInfo) {
      //   setContactInfo(result.ContactInfo);
      // }
      if (
        (state.code && result.CustomerInfo?.TimeZoneID) ||
        (state.code && result.ContactInfo?.TimeZone)
      ) {
        state.timeZone = !result?.CustomerInfo?.TimeZoneID
          ? timeZones.value.find(
              (itm) =>
                parseFloat(itm.code) ===
                parseFloat(result.ContactInfo?.TimeZone)
            )?.code
          : timeZones.value.find(
              (itm) => itm.id === result.CustomerInfo?.TimeZoneID
            )?.code;
      }
    };

    return {
      onSubmit,
      state,
      v$,
      isSubmitted,
      MinorToken,
      timeZones,
      startDateTime,
      endDateTime,
      countries,
      isLoading,
    };
  },
};
</script>


 